import React, { FunctionComponent } from 'react';

import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';

import WithLayout from 'src/components/Layout/WithLayout';
import SearchFormWithNavigation from 'src/components/SearchForm/SearchFormWithNavigation';
import useTrackHomepageView from 'src/tracking/useTrackHomepageView';
import useTranslation from 'src/translations/useTranslation';

export type SearchForm = {
  jobLabel?: string;
  city?: string;
};

export interface HomepageProps {}

const Homepage: FunctionComponent<HomepageProps> = () => {
  const { breakpoint } = useTheme();
  const t = useTranslation();
  const { spacing } = useTheme();

  useTrackHomepageView();

  return (
    <WithLayout>
      <Flex
        flexDirection="column"
        justifyContent="center"
        minHeight="100%"
        margin="auto"
        maxWidth={breakpoint.values.md}
      >
        <Text as="h1" variant="headline3" css={{ textAlign: 'center', marginTop: spacing(3) }}>
          {t('discover_all_jobs')}
        </Text>

        <SearchFormWithNavigation
          flex="1 0 auto"
          margin={{ xs: [4, 4, 4], md: [8, 8, 16] }}
          justifyContent={['space-evenly', 'space-around']}
        />
      </Flex>
    </WithLayout>
  );
};

export default Homepage;
